export {};
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// D:/Projects/MDA/schoolofmusic-ucla/web/app/themes/ucla/node_modules/scrollmonitor/dist/module/src/types.js
// module id = 380
// module chunks = 0